import { cn } from "@newxsystems/shared";
import type { IEffectfulHeroRichTextProps } from "./EffectfulHeroRichText.props";

export const EffectfulHeroRichText = ({ className, content }: IEffectfulHeroRichTextProps) => (
  <div
    className={cn(
      "font-daylight-body text-base leading-[1.6] text-pretty text-ash md:text-[17px] [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-border [&_blockquote]:pl-6 [&_blockquote]:text-ash [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-semibold [&_strong]:text-foreground [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

EffectfulHeroRichText.displayName = "EffectfulHeroBlock::EffectfulHeroRichText";
